import React, { memo } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'

import styles from './UserTaskRow.module.sass'

const UserTaskGroupRow = memo(
	(props) => {
		const { data, className, ...attributes } = props
		const { i18n } = useGlobal()
		const isExpanded = data.expanded
		const fullInfo = !data.expanded

		return (
			<>
				<div
					{...attributes}
					className={`${styles['row'] || ''} ${
						styles['group'] || ''
					} ${className || ''} ${
						isExpanded ? styles['is-expanded'] || '' : ''
					}`}
				>
					<span className={styles['icon-cell']}>
						<span
							className={`${styles['icon-container']} ${
								fullInfo ? styles['with-border'] : ''
							}`}
						>
							<Icon
								className={styles['icon']}
								height='20px'
								width='20px'
								name={fullInfo ? data.icon : 'expanded-arrow'}
							/>
						</span>
					</span>
					<span className={styles['details']}>
						<div>
							<h5>{data.title}</h5>
						</div>
					</span>
					<span className={styles['task-type']} />

					{isExpanded && data.requiringUsers?.length ? (
						<span className={styles['requiring-users']}>
							<Dropdown
								value={data.$selectedUser}
								placeholder={i18n`Applicant user`}
								options={data.requiringUsers}
								onChange={(e) => {
									data.$onChange && data.$onChange(e)
								}}
							/>
						</span>
					) : (
						<span className={styles['injured']} />
					)}
				</div>
				{(data.couple || data.multiple) && (
					<span
						className={`${styles['near-back-row']} ${
							isExpanded ? styles['tiny'] : ''
						}`}
						style={attributes.style}
					/>
				)}
				{fullInfo && data.multiple && (
					<span
						className={styles['far-back-row']}
						style={attributes.style}
					/>
				)}
			</>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.subtitle === nextProps.data.subtitle &&
		prevProps.data.couple === nextProps.data.couple &&
		prevProps.data.multiple === nextProps.data.multiple &&
		prevProps.data.expanded === nextProps.data.expanded &&
		prevProps.data.$selectedUser === nextProps.data.$selectedUser &&
		prevProps.style.top === nextProps.style.top
)

export default UserTaskGroupRow
